import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, RouterModule } from "@angular/router";
import { trigger, transition, style, animate, state } from "@angular/animations";

type ReportCard = {
  id: string;
  title: string;
  image: string;
  alt: string;
  route: string[];
};

@Component({
  selector: "reports-hub-component",
  standalone: true,
  templateUrl: "./reports-hub.component.html",
  styleUrls: ["./programs.component.css"],
  imports: [CommonModule, RouterModule],
  animations: [
    trigger("pageTransition", [
      state("hidden", style({ opacity: 0, visibility: "hidden" })),
      state("visible", style({ opacity: 1, visibility: "visible" })),
      transition("hidden => visible", [animate("400ms ease-out")]),
    ]),
    trigger("cardClick", [
      transition("* => clicked", [
        animate("300ms ease-in-out", style({ opacity: 0, transform: "scale(0.95)" })),
      ]),
    ]),
  ],
})
export class ReportsHubComponent implements OnInit {
  isLoading = true;
  clickedCard: string | null = null;
  imagesLoaded: Record<string, boolean> = {};
  pageTransitionState: "hidden" | "visible" = "visible";
  private isRedirecting = false;

  /** Figma Reports hub: Activity, Meal Summary, Meal Order, Transportation */
  readonly cards: ReportCard[] = [
    {
      id: "activity-report",
      title: "Activity Report",
      image: "assets/images/report-activity.png",
      alt: "Activity Report card",
      route: ["/manage-services/senior-center/reports/activity"],
    },
    {
      id: "meal-summary-report",
      title: "Meal Summary Report",
      image: "assets/images/report-meal-summary.png",
      alt: "Meal Summary Report card",
      route: ["/manage-services/senior-center/reports/meal-summary"],
    },
    {
      id: "meal-order-report",
      title: "Meal Order Report",
      image: "assets/images/report-meal-order.png",
      alt: "Meal Order Report card",
      route: ["/manage-services/senior-center/reports/meal-order"],
    },
    {
      id: "transport-report",
      title: "Transportation",
      image: "assets/images/report-transport.png",
      alt: "Transportation report card",
      route: ["/manage-services/senior-center/reports/transport"],
    },
  ];

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    const token = sessionStorage.getItem("token");
    const staffInfo = sessionStorage.getItem("staffInfo");
    if (!token || !staffInfo) {
      this.redirectToSignIn("Please sign in to continue.");
      return;
    }

    this.cards.forEach((card) => {
      this.imagesLoaded[card.id] = false;
    });

    setTimeout(() => {
      this.isLoading = false;
    }, 150);
  }

  goBack(): void {
    void this.router.navigate(["/manage-services/senior-center"]);
  }

  onCardClick(card: ReportCard, event: Event): void {
    event.preventDefault();
    this.clickedCard = card.id;
    setTimeout(() => {
      void this.router.navigate(card.route);
    }, 300);
  }

  onImageLoad(cardId: string): void {
    this.imagesLoaded[cardId] = true;
  }

  onImageError(cardId: string): void {
    this.imagesLoaded[cardId] = true;
  }

  private redirectToSignIn(errorMessage?: string): void {
    if (this.isRedirecting) {
      return;
    }
    this.isRedirecting = true;
    this.isLoading = true;
    setTimeout(() => {
      this.router.navigate(["/"], {
        replaceUrl: true,
        queryParams: errorMessage ? { error: encodeURIComponent(errorMessage) } : undefined,
      });
    }, 0);
  }
}
